<template>
  <div>
    <policy-header />
    <cookie-policy />
    <policy-footer />
  </div>
</template>
<script>
import PolicyHeader from 'pages/policy-pages/components/header-policy';
import CookiePolicy from 'pages/policy-pages/cookie/components/cookie-policy';
import PolicyFooter from 'pages/policy-pages/components/footer-policy';

export default {
  components: {
    PolicyHeader,
    CookiePolicy,
    PolicyFooter,
  },
};
</script>
